<template>
  <input
    class="kk-radio-button"
    type="radio"
    :checked="checked"
    :disabled="isDisabled"
    :value="inputValue"
    @input="onInput"
  />
</template>

<script>
import { isVue2 } from 'vue-demi';

export default {
  name: 'KkRadioButton',
  props: {
    /** vue2 */
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    /** vue3 */
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    inputValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'update:modelValue'],
  computed: {
    checked() {
      if (isVue2) {
        return this.inputValue === this.value;
      } else {
        return this.inputValue === this.modelValue;
      }
    },
  },
  methods: {
    getValueType(type) {
      return (
        Object.prototype.toString.call(this.inputValue) === `[object ${type}]`
      );
    },
    onInput(e) {
      let currentValue = e.target.value;

      if (this.getValueType('Boolean')) {
        currentValue = JSON.parse(currentValue);
      }

      if (this.getValueType('Number')) {
        currentValue = Number(currentValue);
      }

      if (isVue2) {
        this.$emit('input', currentValue);
      } else {
        this.$emit('update:modelValue', currentValue);
      }
    },
  },
};
</script>
